import { motion } from "framer-motion";
import { Droplets, Users } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PunchCard = () => (
  <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
    {[1, 2, 3, 4, 5, 6].map((n) => {
      const free = n === 6;
      return (
        <motion.div
          key={n}
          initial={{ scale: 0.6, rotate: -20 }}
          whileInView={{ scale: 1, rotate: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ type: "spring", stiffness: 260, damping: 16, delay: n * 0.09 }}
          className={`flex aspect-square flex-col items-center justify-center rounded-2xl border ${free ? "border-transparent bg-neon shadow-[0_0_40px_-6px_rgba(255,43,214,0.8)]" : "border-white/15 bg-black/40"}`}
        >
          {free ? <span className="font-race text-2xl text-white">Free</span> : <Droplets className="h-6 w-6 text-zinc-300" />}
          <span className={`mt-1 font-mono-x text-xs ${free ? "text-white" : "text-zinc-400"}`}>#{n}</span>
        </motion.div>
      );
    })}
  </div>
);

export const Rewards = () => (
  <section id="rewards" data-testid="rewards-section" className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 lg:px-12 lg:py-40">
    <Reveal className="mb-16">
      <Eyebrow num="03">Rewards</Eyebrow>
      <h2 className="font-race mt-6 text-6xl leading-[0.9] text-white sm:text-7xl lg:text-8xl">
        Loyalty pays <span className="text-neon">in oil.</span>
      </h2>
    </Reveal>
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
      <Reveal className="lg:col-span-7" data-testid="rewards-oil-card">
        <div className="relative h-full overflow-hidden rounded-3xl border border-white/10 bg-[var(--surface)] p-7 sm:p-10">
          <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-[var(--vio)]/25 blur-3xl" />
          <div className="relative flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[var(--pink-text)]"><Droplets className="h-4 w-4" /> Oil change rewards</div>
          <h3 className="font-race relative mt-5 text-5xl leading-[0.92] text-white sm:text-6xl">Buy 5 oil changes,<br />get your 6th <span className="text-neon">free!</span></h3>
          <div className="relative mt-10"><PunchCard /></div>
        </div>
      </Reveal>
      <Reveal className="lg:col-span-5" delay={0.1} data-testid="rewards-referral-card">
        <div className="relative flex h-full flex-col justify-between overflow-hidden rounded-3xl border border-white/10 bg-neon p-7 sm:p-10">
          <div className="grain absolute inset-0" />
          <div className="relative flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-white"><Users className="h-4 w-4" /> Referral program</div>
          <div className="relative mt-10">
            <div className="font-race text-5xl leading-[0.92] text-white sm:text-6xl">Refer a friend.<br />Get a free oil change.</div>
            <p className="mt-6 text-base text-white">Ask about our rewards & referral program when we call to confirm your appointment.</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
